/* VERON · Aktionsfenster beim Verlassen der Seite (Exit-Intent) — Auftragsbuch #70, Baustein zu
   snippets/veron-aktion-fenster.liquid (dort: WER das Fenster bekommt; hier: WANN es aufgeht). Doku doku/AKTIONEN-FENSTER.md.
   Nur mit Einwilligung „Präferenzen“ im Shopify-Cookie-Banner (§ 25 TDDDG: sonst weder Speicher lesen noch schreiben,
   kein Fenster), nur Maus + Desktop ab 1024 px, frühestens nach 5 s, Mauszeiger verlässt das Fenster nach oben,
   höchstens einmal je Seitenaufruf und je 30 Tage, nie nach einer Newsletter-Anmeldung (?customer_posted=true), nie
   über einer anderen Ebene (Dialog, Cookie-Banner, modaler Filter, Popover, offenes Kopfmenü), nie während einer Eingabe.
   Merker (localStorage, nichts wird gesendet): veron.fenster.<aktion> = Zeitpunkt (ms), veron.fenster.angemeldet = "1" -
   NUR auf Seiten mit Fenster (C3, 21.10.2026: das Snippet lädt das Skript nur mit dem <dialog>; ohne Fenster tut es
   auch hier nichts, kein Merker).
   Kein beforeunload. showModal(): Fokus im Fenster, Hintergrund inert, ESC/Hintergrund schließen, Fokus kehrt zurück.
   Beim Absenden schließt das Fenster (Shopifys hCaptcha hängt ein Rätsel an <body>, unter dem modalen Dialog nicht
   bedienbar); nach dem Neuladen (#veron-aktion-fenster-form) zeigt es die Meldung. #veron-fenster-probe öffnet sofort.
   Test: tests/saison/aktionen_fenster_render.js (AF-12/AF-13/AF-16). */
(function (w, d) {
  'use strict';
  var TAG_MS = 864e5;
  var REGEL = { sperreTage: 30, scharfMs: 5000, minBreite: 1024, obenPx: 10, einwilligung: 'preferences' };
  var MEDIEN = '(hover: hover) and (pointer: fine)';
  var K_GEZEIGT = 'veron.fenster.';
  var K_ANGEMELDET = 'veron.fenster.angemeldet';
  // Ebenen, über die sich das Fenster nie legt (zusätzlich zu dialog[open] und offenen Popovern): Shopify-Cookie-Banner
  // und -Einstellungen (div mit role alertdialog/dialog, kein <dialog>), modale Filter (aria-modal), offenes Kopfmenü.
  var EBENEN = '#shopify-pc__banner, #shopify-pc__prefs, [role="dialog"], [role="alertdialog"], [aria-modal="true"], ' +
    '#header-component details[open]';

  // Reine Entscheidung: 'zeigen' oder der Grund dagegen (Reihenfolge = Vorrang, getestet in AF-12).
  function entscheiden(z) {
    if (!z.einwilligung) return 'keine-einwilligung';
    if (!z.speicher) return 'kein-speicher';
    if (!z.feinzeiger) return 'kein-feinzeiger';
    if (!(z.breite >= REGEL.minBreite)) return 'zu-schmal';
    if (z.angemeldet) return 'angemeldet';
    if (z.gezeigt !== null && z.gezeigt !== undefined) {
      var g = Number(z.gezeigt);
      if (!(g > 0) || z.jetzt - g < REGEL.sperreTage * TAG_MS) return 'gesperrt';
    }
    if (z.schonHier) return 'schon-gezeigt';
    if (!(z.seitMs >= REGEL.scharfMs)) return 'noch-nicht-scharf';
    if (z.dialogOffen) return 'anderer-dialog';
    if (z.eingabe) return 'eingabe';
    if (z.ziel) return 'kein-austritt';
    if (!(z.y <= REGEL.obenPx)) return 'nicht-oben';
    return 'zeigen';
  }
  w.VeronAktionFenster = { entscheiden: entscheiden, REGEL: REGEL };

  // Einwilligung (Shopify Customer Privacy API, vom Cookie-Banner geladen; Kategorie REGEL.einwilligung - Entscheid Fynn,
  // doku/AKTIONEN-FENSTER.md G8b): ohne API, vor der Entscheidung im Banner oder bei Ablehnung false - dann kein
  // Speicherzugriff und kein Fenster.
  var PRUEF = { preferences: 'preferencesProcessingAllowed', marketing: 'marketingAllowed' };
  function einwilligung() {
    try {
      var cp = w.Shopify && w.Shopify.customerPrivacy, f = cp && cp[PRUEF[REGEL.einwilligung]];
      return typeof f === 'function' && f.call(cp) === true;
    } catch (e) { return false; }
  }
  var s = null, sGeprueft = false;
  function speicher() {
    if (sGeprueft) return s;
    if (!einwilligung()) return null;
    sGeprueft = true;
    try { s = w.localStorage; s.setItem(K_GEZEIGT + 'probe', '1'); s.removeItem(K_GEZEIGT + 'probe'); } catch (e) { s = null; }
    return s;
  }
  function lies(k) { var x = speicher(); try { return x ? x.getItem(k) : null; } catch (e) { return null; } }
  function schreib(k, v) { var x = speicher(); try { if (!x) return false; x.setItem(k, v); return true; } catch (e) { return false; } }

  var ort = w.location || {};
  var angemeldetHier = /(?:^|[?&])customer_posted=true(?:&|$)/.test(String(ort.search || '').replace(/^\?/, ''));
  function angemeldetMerken(rest) {
    if (schreib(K_ANGEMELDET, '1') || !(rest > 0) || typeof w.setTimeout !== 'function') return;
    w.setTimeout(function () { angemeldetMerken(rest - 1); }, 2000);   // Banner/API laden oft erst nach diesem Skript
  }

  var dlg = d.getElementById('veron-aktion-fenster');
  if (!dlg || typeof dlg.showModal !== 'function') return;             // C3: ohne Fenster nichts, auch kein Merker
  if (angemeldetHier) {
    angemeldetMerken(5);
    d.addEventListener('visitorConsentCollected', function () { angemeldetMerken(0); });
  }
  var aktion = dlg.getAttribute('data-veron-fenster') || 'aktion';
  var start = Date.now(), schonHier = false, zurueck = null;

  function oeffnen(merken) {
    if (dlg.open) return;
    if (merken && !schreib(K_GEZEIGT + aktion, String(Date.now()))) return;
    schonHier = true;
    zurueck = d.activeElement;
    dlg.showModal();
  }
  function zu() { if (dlg.open) dlg.close(); }
  dlg.addEventListener('close', function () {
    var z = zurueck; zurueck = null;
    if (z && z !== d.body && typeof z.focus === 'function' && (!d.activeElement || d.activeElement === d.body)) {
      try { z.focus(); } catch (e) { /* Element nicht mehr da */ }
    }
  });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) zu(); });
  dlg.addEventListener('submit', zu, true);              // hCaptcha-Rätsel bedienbar (siehe Kopf); POST läuft weiter
  var knopf = dlg.querySelector('[data-veron-fenster-zu]');
  if (knopf) knopf.addEventListener('click', zu);

  var anker = String(ort.hash || '');
  if (anker === '#veron-aktion-fenster-form' && dlg.querySelector('[data-veron-fenster-meldung]')) { oeffnen(false); return; }
  if (anker === '#veron-fenster-probe') oeffnen(false);

  function feinzeiger() {
    try { return !!(w.matchMedia && w.matchMedia(MEDIEN).matches); } catch (e) { return false; }
  }
  function eingabe() {
    var a = d.activeElement;
    return !!(a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName || '') || a.isContentEditable === true));
  }
  function sichtbar(el) {
    if (!el || el === dlg || (typeof dlg.contains === 'function' && dlg.contains(el))) return false;
    try {
      var cs = w.getComputedStyle ? w.getComputedStyle(el) : null;
      if (cs && (cs.display === 'none' || cs.visibility === 'hidden')) return false;
    } catch (e) { /* weiter mit den Rechtecken */ }
    return !!(el.getClientRects && el.getClientRects().length);
  }
  function ebeneOffen() {
    if (d.querySelector('dialog[open]')) return true;
    var l = d.querySelectorAll(EBENEN);
    for (var i = 0; i < l.length; i++) if (sichtbar(l[i])) return true;
    try { if (d.querySelector('[popover]:popover-open')) return true; } catch (e) { /* Browser ohne :popover-open */ }
    return !!d.querySelector('[popover].\\:popover-open');                // Popover-Polyfill des Themes
  }
  d.addEventListener('mouseout', function (e) {
    if (schonHier || e.relatedTarget || !(e.clientY <= REGEL.obenPx)) return;   // nur der Austritt nach oben zählt
    var jetzt = Date.now(), ew = einwilligung(), sp = ew && !!speicher();
    var z = { einwilligung: ew, speicher: sp, feinzeiger: feinzeiger(), breite: w.innerWidth,
      angemeldet: angemeldetHier || (sp && lies(K_ANGEMELDET) === '1'), gezeigt: sp ? lies(K_GEZEIGT + aktion) : null,
      jetzt: jetzt, schonHier: schonHier, seitMs: jetzt - start, dialogOffen: ebeneOffen(), eingabe: eingabe(),
      ziel: e.relatedTarget || null, y: e.clientY };
    if (entscheiden(z) === 'zeigen') oeffnen(true);
  });
})(window, document);
